<template>
  <div class="startDesc">

    <div class="output">

        <h4>Touchscreens</h4>
        <div class="header flexme">
            <div>Slug</div>
            <div>Text</div>
            <div>Text En</div>
            <div>Orientation</div>
        </div>

        <div class="touchscreens" v-for="ts in options.touchscreens">
            <h3>{{ts.slug}}</h3>
            <div class="">Orientation: {{ts.orientation}}</div>
            <h4>Children</h4>
        </div>


        <h4>Starting Points</h4>
        <div class="header flexme">
            <div>Start</div>
            <div>Text</div>
            <div>Text En</div>
            <div>Orientation</div>
        </div>

      <div class="startingpoint flexme" v-for="point in startDescriptions">
        <div>{{point.id}}->{{point.firstChild}}</div>
        <input type="text" v-model="point.text">
          <input type="text">
        <input type="text" v-model="point.orientation">
      </div>

      <h4>startingpoints New the object</h4>
      <div class="" v-html="startDescriptions"></div>

      <h4>startingpoints old</h4>
      <div class="" v-html="startDescriptionsOLD"></div>

      <h4>Missing Text</h4>
      <div class="output" v-html="missingText"></div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import Advertising from "@/components/Advertising";
import HausNavigation from '@/components/HouseNavigation.vue'
import Node from '@/components/NaviConfig/Node.vue'
import MapCanvas from "@/components/MapCanvas";
import ServicePoint from "@/components/ServicePoint";
import * as nodelib from '@/nodes.js'
export default {
  name: 'StartDescriptions',
  components: {
    Advertising, HausNavigation, Node, MapCanvas, ServicePoint
  },
    props: ['options'],
  data(){
    return {
      nodes: [],
      routes: [],
      startDescriptions: [],
      startDescriptionsOLD: []
    }
  },
  computed: {
    // selectedNode(){
    //     return this.nodes.find(x=> x.isOpen == true)
    // }
    sortedNodes(){
      return this.nodes.sort(function (a,b) {
        return a.id.localeCompare(b.id);
      })
    },


    missingText(){
      let v= this;
      let startingNodes =  this.nodes.filter(x=>x.isStartpoint);
      let missingNodes = [];
      startingNodes.forEach(function (node) {

        Object.keys(node.children).forEach(function (key) {
          let textEl = v.startDescriptions.find( x=> x.id == node.id && x.firstChild == key )
          if (!textEl){
            missingNodes.push(node.id+'->'+key)
          }
        })

      })
      return missingNodes
    }

  },
  created() {
    // load
    this.nodes = nodelib.nodes;
    this.servicePoints = nodelib.servicePoints;
    this.startDescriptionsOLD = nodelib.startDescriptions;
    // this.startingPoints();
      this.startDescriptions = nodelib.startDescriptions;
  },
  mounted(){

    this.fille();
  },

  methods: {
    startingPoints(){
      let v = this;
      let startingPointsArray = [];
      let startingNodes =  this.nodes.filter(x=>x.isStartpoint);

      startingNodes.forEach(function (node, key) {
        Object.keys(node.children).forEach(function (key) {
          startingPointsArray.push({id: node.id, firstChild: key, text: '', orientation: ''})
        })
      });

      startingPointsArray.forEach(function(node){
        let text = '';
        let existingnode = v.startDescriptionsOLD.find(function (x){
          if ( x.id === node.id && x.firstChild === node.firstChild ){
            return true
          }
        })
        if (existingnode){
          console.log(existingnode)
          node.text = existingnode.text
        }
      })

      this.startDescriptions = startingPointsArray

    },

    getNode: function (node) {
      return this.nodes.find(x=>x.id==node)
    }
  }
}
</script>

<style lang="scss">
@import "../../styles/variables";

.output {
  font-size: 10px;
  padding: 20px;
}

.header {
    font-size: 18px;
    font-weight: bold;

}

.flexme {
    display: flex;
    box-sizing: border-box;
  > * {
    margin-right: 20px;
    /*width: 500px;*/
    margin-bottom: 10px;
      //min-width: 150px;
      &:nth-child(1) {
          width: 80px;
      }

    &:nth-child(2) {
      width: 40%;
    }
      &:nth-child(3) {
          width: 40%;
      }
  }
}

</style>


